module.exports = __webpack_public_path__ + "static/media/iPhone14.22311069.png";